exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".alias-error .top-bar{background-color:#fffbe3!important;color:#000!important}.alias-error .popup-inner{bottom:50%!important}.alias-error .error-text{margin:20px!important;font-size:12px!important;color:#666!important;font-weight:700!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/common/PopupErrorComponent/PopupError.less
// module id = 1626
// module chunks = 0